import { ShieldCheck } from "lucide-react";
import { useTranslation } from "react-i18next";
import LegalLayout, { LegalSection } from "./LegalLayout";

export default function PoliticaDePrivacidade() {
  const { t } = useTranslation();

  const sections: LegalSection[] = [
    {
      id: "coleta",
      title: t("politica.s1_title", "1. Coleta de Informações"),
      content: <p>{t("politica.s1_p", "Coletamos informações que você nos fornece diretamente, como quando você preenche um formulário de contato, solicita uma consultoria ou se inscreve em nossa newsletter. As informações podem incluir nome, endereço de e-mail, telefone e nome da empresa.")}</p>,
    },
    {
      id: "uso",
      title: t("politica.s2_title", "2. Uso das Informações"),
      content: (
        <>
          <p>{t("politica.s2_p", "Utilizamos as informações coletadas para:")}</p>
          <ul>
            <li>{t("politica.s2_l1", "Fornecer, manter e melhorar nossos serviços;")}</li>
            <li>{t("politica.s2_l2", "Responder a seus comentários, perguntas e solicitações de suporte;")}</li>
            <li>{t("politica.s2_l3", "Enviar comunicações técnicas, atualizações, alertas de segurança e mensagens administrativas;")}</li>
            <li>{t("politica.s2_l4", "Comunicar sobre produtos, serviços, ofertas, promoções e eventos.")}</li>
          </ul>
        </>
      ),
    },
    {
      id: "compartilhamento",
      title: t("politica.s3_title", "3. Compartilhamento de Informações"),
      content: <p>{t("politica.s3_p", "Não vendemos, trocamos ou transferimos suas informações pessoais para terceiros, exceto quando necessário para fornecer nossos serviços (como parceiros de tecnologia confiáveis) ou quando exigido por lei.")}</p>,
    },
    {
      id: "cookies",
      title: t("politica.s4_title", "4. Cookies e Tecnologias de Rastreamento"),
      content: <p>{t("politica.s4_p", "Utilizamos cookies e tecnologias semelhantes para analisar tendências, administrar o site, rastrear o movimento dos usuários pelo site e coletar informações demográficas sobre nossa base de usuários como um todo. Você pode controlar o uso de cookies através das configurações do seu navegador.")}</p>,
    },
    {
      id: "seguranca",
      title: t("politica.s5_title", "5. Segurança dos Dados"),
      content: <p>{t("politica.s5_p", "Implementamos medidas de segurança técnicas e organizacionais apropriadas para proteger seus dados pessoais contra acesso, alteração, divulgação ou destruição não autorizada. No entanto, nenhum método de transmissão pela Internet ou armazenamento eletrônico é 100% seguro.")}</p>,
    },
    {
      id: "direitos",
      title: t("politica.s6_title", "6. Seus Direitos"),
      content: <p>{t("politica.s6_p", "Você tem o direito de acessar, corrigir, atualizar ou solicitar a exclusão de suas informações pessoais. Você também pode optar por não receber nossas comunicações de marketing a qualquer momento.")}</p>,
    },
    {
      id: "alteracoes",
      title: t("politica.s7_title", "7. Alterações nesta Política"),
      content: <p>{t("politica.s7_p", 'Podemos atualizar esta Política de Privacidade periodicamente. Notificaremos você sobre quaisquer alterações publicando a nova Política de Privacidade nesta página e atualizando a data da "última atualização".')}</p>,
    },
    {
      id: "contato",
      title: t("politica.s8_title", "8. Contato"),
      content: (
        <p>
          {t("politica.s8_p", "Se você tiver dúvidas sobre esta Política de Privacidade ou sobre nossas práticas de dados, entre em contato conosco em:")}{" "}
          <strong>contato@calriz.com.br</strong>
        </p>
      ),
    },
  ];

  return (
    <LegalLayout
      seo={{ page: "politica", path: "/politica-de-privacidade" }}
      title={t("politica.title", "Política de Privacidade")}
      icon={ShieldCheck}
      intro={<p>{t("politica.intro", "A Calriz valoriza sua privacidade e está comprometida em proteger seus dados pessoais. Esta Política de Privacidade explica como coletamos, usamos e protegemos suas informações.")}</p>}
      sections={sections}
      updated={t("politica.last_update", "Última atualização: Janeiro de 2026")}
    />
  );
}
